import React from "react";
import { Brush, Wrench, Sparkles, Leaf } from "lucide-react";

const ICONS = [Brush, Wrench, Sparkles, Leaf];

export default function Services({ t }) {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 md:py-32 bg-white border-t border-slate-200"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 mb-14">
          <div className="lg:col-span-5">
            <div
              className="text-[12px] tracking-[0.28em] uppercase text-[#475569] mb-4"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              — {t.services.eyebrow}
            </div>
            <h2
              className="text-[36px] sm:text-[44px] leading-[1.05] tracking-tight text-[#0A0F1C] font-medium"
              style={{ fontFamily: "'Outfit', sans-serif" }}
            >
              {t.services.title}
            </h2>
          </div>
          <div className="lg:col-span-6 lg:col-start-7 flex items-end">
            <p
              className="text-[16px] leading-relaxed text-[#475569]"
              style={{ fontFamily: "'Manrope', sans-serif" }}
            >
              {t.services.desc}
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-slate-200">
          {t.services.items.map((it, i) => {
            const Icon = ICONS[i % ICONS.length];
            return (
              <div
                key={i}
                data-testid={`service-card-${i}`}
                className="bg-white p-8 md:p-10 flex flex-col gap-6 group hover:bg-[#0F2C29] transition-colors duration-300"
              >
                <Icon
                  className="w-9 h-9 text-[#0F2C29] group-hover:text-white transition-colors"
                  strokeWidth={1.4}
                />
                <h3
                  className="text-[22px] leading-tight text-[#0A0F1C] group-hover:text-white font-medium transition-colors"
                  style={{ fontFamily: "'Outfit', sans-serif" }}
                >
                  {it.title}
                </h3>
                <p
                  className="text-[14px] leading-relaxed text-[#475569] group-hover:text-white/80 transition-colors"
                  style={{ fontFamily: "'Manrope', sans-serif" }}
                >
                  {it.desc}
                </p>
                <div className="mt-auto pt-4 border-t border-slate-200 group-hover:border-white/20 transition-colors">
                  <span
                    className="text-[11px] tracking-[0.22em] uppercase text-[#0F2C29] group-hover:text-white transition-colors"
                    style={{ fontFamily: "'Manrope', sans-serif" }}
                  >
                    0{i + 1}
                  </span>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
